import React, { useEffect, useState } from "react";
import "./index.css";
import done from "../../../assets/media/icon/done.svg";
const PopUp = ({ timeout, message, status }) => {
  const [timeRemaining, setTimeRemaining] = useState(6);
  useEffect(() => {
    if (timeRemaining > 0) {
      const timerId = setInterval(() => {
        setTimeRemaining((prevTime) => prevTime - 1);
      }, 1000);
      return () => clearInterval(timerId);
    }
  }, [timeRemaining]);
  return (
    <div className={`popup  ${status ? " visible" : ""}`}>
      <div className={`popup-container  ${status ? status : ""}`}>
        <img src={status === "done" ? done : ""} alt="" />
        <div className="message">{message}</div>
        <div className="count-down">{timeRemaining}</div>
      </div>
    </div>
  );
};

export default PopUp;
